/* eslint-disable @typescript-eslint/no-unused-vars */
import { PendingInitializationTrackingManager } from "./PendingInitializationTrackingManager";
import { TrackingManagerState } from "./TrackingManagerState";
import {
	TrackedEventData,
	InternalEventData,
	GaEventData,
} from "../types/EventsData";

const UNINITIALIZED_TRACKING_MANAGER_ERROR =
	"Please initialize TrackingManager before using it.";

const DEFAULT_PENDING_INITIALIZATION_TRACKING_MANAGER_FACTORY = () => {
	return new PendingInitializationTrackingManager();
};

/**
 * This class is responsible for the initial state of the TrackingManager.
 * It is used for troubleshooting issues with the initialization of the TrackingManager.
 * If the 'initialize' function of the TrackingManager has not been called for some reason, this class will throw errors in the console and notify developers.
 */
export class UninitializedTrackingManager extends TrackingManagerState {
	constructor(
		private readonly createPendingInitializationTrackingManager: () => TrackingManagerState = DEFAULT_PENDING_INITIALIZATION_TRACKING_MANAGER_FACTORY
	) {
		super();
	}

	initialize(): Promise<void> {
		return this.trackingManager.transitionToState(
			this.createPendingInitializationTrackingManager()
		);
	}

	trackSharingEvent(_webuserDataId: string): void {
		throw new Error(UNINITIALIZED_TRACKING_MANAGER_ERROR);
	}

	trackSignedEvent(_webuserDataId: string): void {
		throw new Error(UNINITIALIZED_TRACKING_MANAGER_ERROR);
	}

	submitTrackedEvent(_eventData: TrackedEventData): void {
		throw new Error(UNINITIALIZED_TRACKING_MANAGER_ERROR);
	}

	submitInternalEvent(_eventData: InternalEventData): void {
		throw new Error(UNINITIALIZED_TRACKING_MANAGER_ERROR);
	}

	submitGAEvent(_eventData: GaEventData): void {
		throw new Error(UNINITIALIZED_TRACKING_MANAGER_ERROR);
	}

	trackContractSection(_newSection: string, _newGroup: string): void {
		throw new Error(UNINITIALIZED_TRACKING_MANAGER_ERROR);
	}
}
